document.addEventListener('DOMContentLoaded', () => {
  const heading = document.querySelector('[data-af-bundle-compact-heading]');
  const link = document.querySelector('[data-af-bundle-builder-anchor]');
  if (!heading || !link) return;
  function anchorOffset() {
    const header = document.querySelector('.af-header-section') || document.querySelector('[data-af-header]');
    const offset = Math.ceil(header?.getBoundingClientRect().height || 128) + 16;
    heading.style.setProperty('--af-bundle-anchor-offset', `${offset}px`);
    return offset;
  }
  anchorOffset();
  window.addEventListener('resize', anchorOffset, { passive: true });
  link.addEventListener('click', (event) => {
    event.preventDefault();
    const top = Math.max(0, window.scrollY + heading.getBoundingClientRect().top - anchorOffset());
    heading.focus({ preventScroll: true });
    window.scrollTo({ top, left: 0, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
  });
});
